import { connect } from 'react-redux';
import ColorOptions from './ColorSwatches';

import { getSKUData, getProductOutOfStock, getProductUrl } from 'shared/store/details/selectors';

import {
  getColorOptions,
  getDefaultColor,
  getCurrentImage,
  getAspectRatio,
} from 'shared/layouts/DetailsPage/components/ProductInfo/components/ColorSwatches/helpers';

const mapStateToProps = (state: any) => {
  const skuData = getSKUData(state);
  return {
    defaultColor: getDefaultColor(skuData),
    colorOptions: getColorOptions(skuData),
    currentImage: getCurrentImage(skuData),
    aspectRatio: getAspectRatio(skuData),
    isCurrentInStock: !getProductOutOfStock(state),
    currentUrl: getProductUrl(state),
  };
};

export default connect(mapStateToProps)(ColorOptions);
